import { useSetAtom } from 'jotai'
import { voiceDialogAtom, type VoiceTopic } from '@/store/voiceAtoms'
import { trackUserVoice, type VoiceOpenSource } from '@/modules/userVoiceAnalytics'

interface OpenVoiceOptions {
  /** Where the dialog was opened from — recorded on the `user_voice:open` event for attribution. */
  source: VoiceOpenSource
  presetTopic?: VoiceTopic
}

export const useUserVoice = () => {
  const setDialog = useSetAtom(voiceDialogAtom)
  return {
    openVoice: ({ source, presetTopic }: OpenVoiceOptions) => {
      trackUserVoice('user_voice:open', { source, presetTopic })
      setDialog({ open: true, presetTopic })
    },
    closeVoice: () => setDialog({ open: false }),
  }
}
